import { render } from "./AppointmentView.vue?vue&type=template&id=8631f05e&ts=true"
import script from "./AppointmentView.vue?vue&type=script&lang=ts"
export * from "./AppointmentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__